// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.ce-paragraph {
	line-height: 1.6em;
	outline: none;
}*/
/**
 * Normally paragraph placeholder is shown only for the focused block (thanks to "data-placeholder-active").
 *
 * But there is a special case when the paragraph is the only block in the empty editor.
 * When editor autofocus=false, there will be no focus. We need to show the placeholder anyway.
 */
/*.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty::before,
.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty="true"]::before {
	content: attr(data-placeholder-active);
}

.ce-paragraph p:first-of-type {
	margin-top: 0;
}

.ce-paragraph p:last-of-type {
	margin-bottom: 0;
}*/`, "",{"version":3,"sources":["webpack://./assets/js/components/editorjs/components/block-paragraph/index.css"],"names":[],"mappings":"AAAA;;;EAAA;AAKA;;;;;EAAA;AAOA;;;;;;;;;;;EAAA","sourcesContent":["/*.ce-paragraph {\r\n\tline-height: 1.6em;\r\n\toutline: none;\r\n}*/\r\n\r\n/**\r\n * Normally paragraph placeholder is shown only for the focused block (thanks to \"data-placeholder-active\").\r\n *\r\n * But there is a special case when the paragraph is the only block in the empty editor.\r\n * When editor autofocus=false, there will be no focus. We need to show the placeholder anyway.\r\n */\r\n\r\n/*.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty::before,\r\n.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=\"true\"]::before {\r\n\tcontent: attr(data-placeholder-active);\r\n}\r\n\r\n.ce-paragraph p:first-of-type {\r\n\tmargin-top: 0;\r\n}\r\n\r\n.ce-paragraph p:last-of-type {\r\n\tmargin-bottom: 0;\r\n}*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
